const resetVideo = (node) => {
  const src = node.src;
  node.src = '';
  node.src = src;
};

const updateSlider = (node) => {
  window.worksSlidersList.forEach((slider) => {
    const isMatch = slider.$element === node;

    if (isMatch) {
      slider.update();
    }
  });
};

const toggleFoldingBlock = (node) => {
  const $video = node.querySelector('.folding-block__video iframe') || false;
  const $slider = node.querySelector('.js-works-slider') || false;

  node.classList.toggle('is-open');

  if ($video) {
    resetVideo($video);
  }

  if ($slider) {
    updateSlider($slider);
  }
};

const addFoldingBlockListener = () => {
  document.addEventListener('click', (evt) => {
    const $target = evt.target;
    const $showBtn = $target.closest('.js-show-folding-block') || false;

    if ($showBtn) {
      const $foldingBlock = $showBtn.closest('.js-folding-block') || false;
      toggleFoldingBlock($foldingBlock);
    }
  });
};

export {addFoldingBlockListener, toggleFoldingBlock};
